import type { Contributor, ProductContributor } from "~/models/Content/schemas"
import * as v from "valibot"
import { ContributorSchema } from "~/models/Content/schemas"

export interface ProductContributorWithDetails extends ProductContributor {
  details?: Contributor
}

export function useProductContributors() {
  const productContent = useProductContentStore()

  const contributors = computed(() => {
    return productContent
      .activeSubject
      ?.crediting
      .sort((a, b) => Number(b.isMainAuthor) - Number(a.isMainAuthor))
      .map<ProductContributorWithDetails>(productContributor => ({
        ...productContributor,
        details: productContributor
          .relatedItems
          .filter(i => v.is(ContributorSchema, i))[0],
      }))
  })

  return { contributors }
}
